import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIn, setIn } from 'formik';
import classNames from 'classnames';

import branch from 'client/core/branch';

import UserActions from 'client/actions/User';
import SrFilterSearchBar from 'client/components/SrFilterSearchBar/SrFilterSearchBar';
import './SrUserSettingDropdownWithSearchBar.less';

export const SR_USER_SETTING_DROPDOWN_WITH_SEARCH_BAR_THEME_ADMIN =
  'SR_USER_SETTING_DROPDOWN_WITH_SEARCH_BAR_THEME_ADMIN'; // eslint-disable-line max-len
const SR_USER_SETTING_DROPDOWN_WITH_SEARCH_BAR_THEME_TO_CLASSNAME_MAPPING = {
  [SR_USER_SETTING_DROPDOWN_WITH_SEARCH_BAR_THEME_ADMIN]: 'admin',
};

@branch({
  currentUser: ['currentUser'],
})
class SrUserSettingDropdownWithSearchBar extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dropdownOptions: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    settingField: PropTypes.string.isRequired,
    useUppercase: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    const settingValue = getIn(props.currentUser.settings, props.settingField);
    this.options = [
      {
        label: 'All',
        value: undefined,
      },
      ...(props.dropdownOptions || []),
    ];
    this.state = {
      settingValue: settingValue,
      filteredOptions: this.options,
    };
  }

  _onChangeOptionId = (optionId) => {
    const { currentUser, settingField, dispatch } = this.props;
    const { settingValue } = this.state;
    let newSettingValue;
    if (optionId === undefined) {
      newSettingValue = undefined;
    } else if (Array.isArray(settingValue)) {
      newSettingValue = settingValue.includes(optionId)
        ? settingValue.filter((id) => id !== optionId)
        : [...settingValue, optionId];
    } else {
      newSettingValue = settingValue ? [settingValue, optionId] : [optionId];
    }

    newSettingValue =
      newSettingValue && newSettingValue.length === 0 ? this.options[0].value : newSettingValue;

    this.setState({ settingValue: newSettingValue });
    const newUserSettings = setIn({ ...currentUser.settings }, settingField, newSettingValue);

    dispatch(UserActions.updateSettings, newUserSettings);
  };

  _getDropdownTitle = () => {
    const { settingValue } = this.state;
    const { useUppercase } = this.props;
    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];
    const optionsActive = this.options.filter(({ value }) =>
      Array.isArray(value)
        ? settingValueArray.includes(value[0])
        : settingValueArray.includes(value),
    );
    const dropdownTitle =
      optionsActive.length === 1 ? optionsActive[0].label : `${optionsActive.length} selected`;

    return (
      <span
        styleName={classNames('status', {
          active: optionsActive.length > 0 && optionsActive[0].label !== 'All',
          uppercase: useUppercase,
        })}
      >
        {dropdownTitle || '...'}
      </span>
    );
  };

  _filterOptions = (newOptions) => {
    this.setState({ filteredOptions: newOptions });
  };

  render() {
    const { settingValue, filteredOptions } = this.state;
    const { theme, title, notFoundTitle } = this.props;

    const { useUppercase } = this.props;

    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];
    const optionsArray = filteredOptions.map((option) => ({
      id: option.value,
      title: option.label,
      isActive: settingValueArray.includes(option.value),
    }));

    return (
      <div
        styleName={classNames(
          'SrUserSettingDropdownWithSearchBar',
          SR_USER_SETTING_DROPDOWN_WITH_SEARCH_BAR_THEME_TO_CLASSNAME_MAPPING[theme],
        )}
      >
        <span styleName={classNames('label', { uppercase: useUppercase })}>{title}:</span>
        {this._getDropdownTitle()}
        <div styleName={classNames('dropdownContainer')}>
          <SrFilterSearchBar
            fuzzySearchOptions={this.options}
            onFilterOptions={this._filterOptions}
          />
          {optionsArray.map((option) => (
            <span
              key={`${option.id}`}
              styleName={classNames('option', {
                active: option.isActive,
                multiple: true,
                uppercase: useUppercase,
              })}
              onClick={() => this._onChangeOptionId(option.id)}
            >
              {option.title}
            </span>
          ))}
          {optionsArray.length === 0 && (
            <span styleName={classNames('fallback')}>{notFoundTitle}</span>
          )}
        </div>
      </div>
    );
  }
}

SrUserSettingDropdownWithSearchBar.displayName = 'SrUserSettingDropdownWithSearchBar';

export default SrUserSettingDropdownWithSearchBar;
